import React from 'react';
import {withTranslation} from "react-i18next";

const BankTransferForm = ({ t }) => (
    <div className="payment-type-bloc">
        <p className="payment-text"><span className="cards-title">{t('followup.bank_transfer_information')} : </span></p>
        <table className="iban-table">
            <thead>
                <tr>
                    <th>{t('followup.bank_code')}</th>
                    <th>{t('followup.box_code')}</th>
                    <th>{t('followup.account_number')}</th>
                    <th>{t('followup.rib_key')}</th>
                    <th>{t('followup.domicile')}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>16807</td>
                    <td>00350</td>
                    <td>40421719721</td>
                    <td>96</td>
                    <td>BPMC LE PUY</td>
                </tr>
            </tbody>
        </table>
        <table className="iban-table">
            <thead>
                <tr>
                    <th colSpan="7">{t('followup.iban')}</th>
                    <th>{t('followup.bic')}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>FR76</td>
                    <td>1680</td>
                    <td>7003</td>
                    <td>5040</td>
                    <td>4217</td>
                    <td>1972</td>
                    <td>196</td>
                    <td>CCBPFRPPGRE</td>
                </tr>
            </tbody>
        </table>
        <p className="payment-text">
            <span className="cards-title">{t('followup.account_label')} : </span><br />
            La Malle Postale<br />
            Rue du 11 novembre 1918<br />
            43370 Cussac-sur-Loire
        </p>
    </div>
);

export default withTranslation()(BankTransferForm);
